<script>
  export let title = '';
  export let className = '';
  export let href = '';
  export let type = 'button';   
  export let onClick = null; 
</script>

{#if href}
  <a href={href} class={`flex w-full font-bold items-center pb-0.5 justify-center text-[17px] leading-none text-center px-5 h-10 rounded-full duration-150 ring-1 ring-inset ring-white bg-white hover:bg-white/80 text-primary active:bg-white/80 ${className}`} on:click={onClick}>
    {title}
  </a>
{:else}
  <button type={type} class={`flex w-full font-bold items-center pb-0.5 justify-center text-[17px] leading-none text-center px-5 h-10 rounded-full duration-150 ring-1 ring-inset ring-white bg-white hover:bg-white/80 text-primary active:bg-white/80 ${className}`} on:click={onClick}>
    {title}
  </button>
{/if}

